import React from 'react';

import Popover from 'Views/Components/_HumanWritten/Popover';

interface Props {
	/** What to say about the capacity — that it is closed, or that it is sold out. */
	text: string;
	/** The chip itself, which is the thing being hovered or tapped. */
	children: React.ReactNode;
}

/**
 * What state a capacity is in, on hover or on tap.
 *
 * <p><b>A floating popover, not the app's CSS tooltip.</b> `.custom-tooltip` positions its panel
 * absolutely inside the chip, and every ancestor between a capacity chip and the page sets
 * `overflow: hidden` to keep its corners rounded — the fare table, the chosen card's shell and, on
 * a phone, the sailing card. The panel was being sliced off at the bottom of the row. This is the
 * same mechanism the fare table's own "what this class includes" uses: portalled out and pinned to
 * the trigger, so it escapes all three.</p>
 *
 * <p>`openOnHover` gives the desktop its hover and leaves the phone its tap — see `Popover`.</p>
 */
export default function CapacityStateTooltip({ text, children }: Props) {
	return (
		<Popover
			floating
			openOnHover
			// The card behind this is itself a button — see `stopPropagation`.
			stopPropagation
			containerClassName="capacity-state"
			buttonClassName="capacity-state__trigger"
			popoverClassName="capacity-state__panel"
			buttonContent={children}
			popoverContent={() => text}
		/>
	);
}
